import axiosClient from './axiosClient';

const deviceController = {
  saveDevice(token, accessToken, data) {
    const url = `/api/device?${accessToken}`;
    const payload = data;
    return axiosClient.post(url, payload, {
      headers: {
        'X-Authorization': 'Bearer ' + token,
      },
    });
  },
  getDeviceCredentialsByDeviceId(token, deviceId) {
    const url = `/api/device/${deviceId}/credentials`;
    return axiosClient.get(url, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
  },
  getCustomerDevices(token, customerId, pageSize = 1000, page = 0) {
    const url = `/api/customer/${customerId}/devices?pageSize=${pageSize}&page=${page}`;
    return axiosClient.get(url, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
  },
  assignDeviceToCustomer(token, newCustomerId, deviceId) {
    const url = `/api/customer/${newCustomerId}/device/${deviceId}`;
    const payload = {};
    return axiosClient.post(url, payload, {
      headers: {
        'X-Authorization': 'Bearer ' + token,
      },
    });
  },
  getTenantDeviceInfos(token, type, page = 0, pageSize = 1000) {
    const url = `/api/tenant/deviceInfos?page=${page}&pageSize=${pageSize}&type=${type}`;
    return axiosClient.get(url, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
  },
};

export default deviceController;
